export default __webpack_public_path__ + "fonts/e7a6dc317f75df0df8c59c9de8b1820b.svg";